import { createContext, useState } from "react";

const AuthContext = createContext({
    isLogged:false,
    id:"",
    token:"",
    username:"",
    role:"",
    phone:0,
    phoneHandler:(num) => {},
    login: (data) => {},
    logout: () => {}
})

export const AuthContextProvider = (props) => {
    
    const [token,setToken] = useState(null)
    const [role,setRole] = useState("")
    const [id,setId] = useState("")
    const [phone,setPhone] = useState(0)
    const [username,setUsername] = useState("")

    const userIsLog = !!token;

    const loginHandler = (data) => {
        setToken(data.token);
        setId(data.user_id)
        setUsername(data.user_name)
    }

    const phoneHandler = (phone_num) => {
        setPhone(phone_num)
    }

    const logoutHandler = () => {
        setToken(null);
        setUsername(null);
    }

    const contextValue = {
        token:token,
        username:username,
        id:id,
        role:role,
        phone_number:phone,
        isLogged:userIsLog,
        login: loginHandler,
        logout : logoutHandler,
        phoneHandler:phoneHandler
    }

    return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>
}

export default AuthContext 